/* CSS */
import "@js/parts/css";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

/* Project imports */
import { createCarousel } from '@js/inject';

console.log('Core.js loaded!');

// Get the current script tag
const thisScript = document.currentScript;
// Get excluded IDs
const excludeIds = thisScript.getAttribute('data-exclude');

const apiEndpoint = import.meta.env.VITE_API_URL;
if (apiEndpoint) {
    console.log(`Using API URL: ${apiEndpoint}`);
} else {
    console.warn('VITE_API_URL is not defined in environment variables.');
}

// Function to fetch data from an external API
async function fetchCarouselData() {
    try {
        // Get the API endpoint URL, excluding IDs if any
        const url = apiEndpoint + (excludeIds ? '?exclude='+excludeIds : '');

        // Get API data - Forces the browser to fetch the resource from the remote server
        const response = await fetch(url, {cache: 'no-store'});
        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error fetching carousel data:', error);
    }
}

// Function to initialize the carousel
async function initCarousel() {
    const targetElementId = 'jdl-rentals-carousel-container';

    const container = document.createElement('div');
    container.id = targetElementId;
    document.body.prepend(container);

    const targetElement = document.getElementById(targetElementId);

    console.info(`Target element '${targetElementId}' found. Fetching carousel data...`);
    const carouselData = await fetchCarouselData();
    createCarousel(targetElement, carouselData);
}

// Automatically initialize the carousel when core.js is loaded
initCarousel().then();
